import { Button, Card, Col, Form, Input, Layout, Row, Space, Typography, notification } from 'antd';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useForgotPasswordMutation } from '../../../app/api/authApiSlice';
import AppFooter from '../../../components/layout/AppFooter';
import AppLogo from '../../../components/layout/AppLogo';

const { Text } = Typography;

const ForgotPassword: React.FC = () => {
  const navigate = useNavigate();

  const [forgotPassword, { isLoading }] = useForgotPasswordMutation();

  const handleForgotPassword = ({ email }: any): void => {
    void (async () => {
      try {
        await forgotPassword({ email }).unwrap();
        notification.success({
          message: 'Password reset',
          description: 'Password reset email sent',
        });
        navigate('/');
      } catch (error: any) {
        console.log(error)
      }
    })();
  };

  return (
    <Layout>
      <Layout.Content>
        <Row justify='center' align='middle' style={{ minHeight: '100vh' }}>
          <Col xs={20} sm={16} md={12} lg={10} xl={6} xxl={6}>
            <Card>
              <Space direction='vertical' size='middle' style={{ display: 'flex' }}>
                <Row justify='center'>
                  <AppLogo size={128} />
                </Row>
                <Row justify='center'>
                  <Text>Enter your email address</Text>
                </Row>
                <Form
                  name='login'
                  initialValues={{ remember: true }}
                  onFinish={handleForgotPassword}
                  autoComplete='off'
                  layout='vertical'
                >
                  <Form.Item
                    name='email'
                    rules={[
                      {
                        required: true,
                        message: 'Please input your email address!',
                      },
                    ]}
                  >
                    <Input placeholder='email address' />
                  </Form.Item>
                  <Form.Item wrapperCol={{ span: 32 }}>
                    <Button type='primary' htmlType='submit' block loading={isLoading}>
                      Reset Password
                    </Button>
                    <Button
                      type='link'
                      onClick={() => navigate('/login')}
                      style={{ float: 'right' }}
                    >
                      Back to Login Page
                    </Button>
                  </Form.Item>
                </Form>
              </Space>
            </Card>
            <AppFooter />
          </Col>
        </Row>
      </Layout.Content>
    </Layout>
  );
};

export default ForgotPassword;
